import React, { useState } from "react";

interface Benefit {
  title: string;
  description: string;
}

const BENEFITS: Record<"buyer" | "vendor", Benefit[]> = {
  buyer: [
    {
      title: "Pay without fear",
      description: "Your money stays in escrow until the seller delivers what you agreed.",
    },
    {
      title: "Inspect before release",
      description: "Confirm the item, service, or delivery before funds move to the seller.",
    },
    {
      title: "Dispute support",
      description: "Upload evidence and pause a release when something does not match the deal.",
    },
    {
      title: "Buy anywhere",
      description: "Use VendStash for Instagram, WhatsApp, marketplaces, and direct vendor purchases.",
    },
  ],
  vendor: [
    {
      title: "Prove funds first",
      description: "See that the buyer has paid into escrow before you package or deliver.",
    },
    {
      title: "Share payment links",
      description: "Create a secure link for buyers without building a storefront first.",
    },
    {
      title: "Deliver with confidence",
      description: "Tracking, proof, and order status keep both sides aligned.",
    },
    {
      title: "Get paid on confirmation",
      description: "Funds release to your bank once delivery is accepted or verified.",
    },
  ],
};

interface RoleTabsProps {
  initialRole?: "buyer" | "vendor";
}

const RoleTabs: React.FC<RoleTabsProps> = ({ initialRole = "buyer" }) => {
  const [role, setRole] = useState<"buyer" | "vendor">(initialRole);

  return (
    <div className='role-panel'>
      <h3 className='role-panel__title'>What best describes you?</h3>
      <div className='role-tabs' role='tablist' aria-label='Choose how you use VendStash'>
        {(["buyer", "vendor"] as const).map((r) => (
          <button
            key={r}
            aria-controls={`role-panel-${r}`}
            aria-selected={role === r}
            className='role-tabs__tab'
            id={`role-tab-${r}`}
            role='tab'
            tabIndex={role === r ? 0 : -1}
            type='button'
            onClick={() => setRole(r)}>
            {r === "buyer" ? "Buyer" : "Vendor"}
          </button>
        ))}
      </div>
      <div
        aria-labelledby={`role-tab-${role}`}
        className='role-benefits'
        id={`role-panel-${role}`}
        role='tabpanel'
        tabIndex={0}>
        {BENEFITS[role].map((b) => (
          <article className='role-benefit' key={b.title}>
            <h4>{b.title}</h4>
            <p>{b.description}</p>
          </article>
        ))}
      </div>
    </div>
  );
};

export default RoleTabs;
